import { useEffect, useMemo, useRef, useState } from 'react'
import { debounce } from 'lodash'
import styled from 'styled-components'

import Search from '~/shared/assets/icons/Search'
import theme from '~/shared/styles/theme'

function SearchBar({
  keyword,
  onSearch,
}: {
  keyword: string
  onSearch: (keyword: string) => void
}) {
  const [inputValue, setInputValue] = useState(keyword)
  const inputRef = useRef<HTMLInputElement>(null)

  const debounceMemoChange = useMemo(
    () => debounce((_input: string) => {}, 500),
    [],
  )

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }, [keyword])

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let input = event.target.value
    setInputValue(input)
    debounceMemoChange(input)
  }
  const handleSearch = () => {
    onSearch(inputValue)
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleSearch()
    }
  }

  return (
    <Wrapper>
      <TextField
        ref={inputRef}
        placeholder="검색어를 입력하세요."
        value={inputValue}
        onChange={handleInputChange}
        onKeyUp={handleKeyPress}
      />
      <SearchIcon onClick={handleSearch} />
    </Wrapper>
  )
}

export default SearchBar

const Wrapper = styled.div`
  display: flex;
  align-items: center;

  width: 380px;
  height: 45px;

  border-bottom: 2px solid #313634;

  @media ${theme.device.medium} {
    width: 100%;
  }
`

const TextField = styled.input`
  width: 100%;
  height: 100%;

  font-size: 16px;

  border: none;
  border-bottom: 2px solid #313634;
  outline: none;

  &::placeholder {
    font-size: 18px;
    font-weight: 500;
    line-height: 25px;
    color: #838685;
  }
`

const SearchIcon = styled(Search)`
  cursor: pointer;
`
